// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"Navbar_shadowed__1gOva","active":"Navbar_active__1o4qU"};